'use strict';

function nollstallSok() {
    document.getElementById('sok-fastighet-felanmalan').value = '';
    af.removeAllChildNodes(document.getElementById('soktraffar-felanmalan'));

    const adresser = document.querySelectorAll('[id^="adresser-"]');
    adresser.forEach(el => { el.classList.add('d-none') });

    const gaVidareKnapp = document.getElementById('ga-vidare-en-adress');
    gaVidareKnapp.classList.add('d-none');
}


function rensaBeskrivning() {
    const gaVidareKnapp = document.getElementById('ga-vidare-adress');
    gaVidareKnapp.classList.add('d-none');
    document.getElementById('Formular_Beskrivning').value = '';
    document.querySelector('#felanmalan-formular-beskrivning h2').innerHTML = '';
    document.querySelector('#felanmalan-formular-beskrivning h3').innerHTML = '';
    document.querySelector('#felanmalan-formular-beskrivning p').innerHTML = '';
    document.querySelector('#felanmalan-formular-beskrivning .kundservice-telefon small').innerHTML = '';
    document.querySelector('[id$=ValdAdress]').value = '';
    document.querySelector('[id$=FastighetsEpostadress]').value = '';
}

function rensaKontaktuppgifter() {
    document.getElementById('Formular_Namn').value = '';
    document.getElementById('Formular_Foretag').value = '';
    document.getElementById('Formular_Telefon').value = '';
    document.getElementById('Formular_Mejladress').value = '';
}

const felanmalansida = {
    visaBekraftelse: function() {
        document.querySelectorAll('[id^="w-steg-"]').forEach(function(e) { e.classList.remove('d-none'); });
        document.querySelectorAll('[id^="w-steg-"]').forEach(function(e) { e.classList.remove('active'); });
        document.querySelectorAll('[id^="w-link-steg-"]').forEach(function(e) { e.classList.add('d-none'); });

        document.getElementById('w-steg-4').classList.add('active');
        document.getElementById('w-steg-4').scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
        });
        document.getElementById('w-steg-1').classList.add('d-none');
        document.getElementById('w-link-steg-1').classList.remove('d-none');

        document.getElementById('felanmalan-w4').classList.remove('d-none');

        nollstallSok();
        rensaBeskrivning();
        rensaKontaktuppgifter();
    }
};

(function () {
    const sokinput = document.getElementById('sok-fastighet-felanmalan');
    const sokresultdiv = document.getElementById('soktraffar-felanmalan');
    const sokform = document.getElementById('sok-fastighet-felanmalan-form');

    

    hyresgaster.initSokFastighetFelanmalan(sokform, sokinput, sokresultdiv);
    initResultLinks();
    initWizardTillbakaTillSteg1();
    initWizardGaVidareTillKontaktuppgifter();
    initWizardTillbakaTillBeskrivning();
    nollstallFelmeddelandeFelbeskrivningOmAndring();

    function nollstallFelmeddelandeFelbeskrivningOmAndring() {
        $('#Formular_Beskrivning').on('keyup', function () {
            if ($('#Formular_Beskrivning').val().trim().length >= 1) {
                doljFelmeddelande();
            }
        });

        const el = document.querySelectorAll('.form-multifile--list');
        if (el) {
            [...el].forEach((item) => {
                item.addEventListener('click', e => {
                    if (e.target.matches('button')) {
                        const MAX_FILE_SIZE = AlectaFastigheter.CustomMultifile.getMaxFileSize();
                        const totalFileSize = (AlectaFastigheter.CustomMultifile.sumFileSizes(AlectaFastigheter.CustomMultifile.uploadedFiles) / 1024).toFixed(2);

                        if (totalFileSize <= MAX_FILE_SIZE) {
                            doljFilFelmeddelande();
                        }
                    }
                })
            })
        }
    }

    function initResultLinks() {
        sokresultdiv.addEventListener('click', function (e) {
            if (e.target.nodeName === 'A') {
                nollstallSok();
                rensaBeskrivning();
                rensaKontaktuppgifter();

                const link = e.target;
                sokinput.value = link.innerHTML;
                var arAdress = link.getAttribute('data-address-result');
                var enAdress = link.getAttribute('data-enbart-en-adress');
                var extratext = link.getAttribute('data-extraText');

                const faqLink = link.getAttribute('data-anmalan');
                const faqelement = document.getElementById('faq-link');
                let safeFaqLink = encodeURI(faqLink);
                faqelement.href = safeFaqLink;

                if (arAdress === 'true') {
                    let arBostadsadress = link.getAttribute('data-ar-bostadsadress');
                    document.getElementById('felanmalan-w1').classList.add('d-none');
                   
                    gaVidareTillSteg2(link, link.dataset.adress, arBostadsadress, extratext);
                } else if (enAdress === 'true') {
                    let arBostadsadress = link.getAttribute('data-ar-bostadsadress');
                    document.getElementById('felanmalan-w1').classList.add('d-none');

                    const gaVidareKnapp = document.getElementById('ga-vidare-adress');
                    gaVidareKnapp.classList.remove('d-none');
                    gaVidareKnapp.addEventListener('click', function (e) {
                        gaVidareTillSteg2(link, link.dataset.adress, arBostadsadress, extratext);
                    });

                    gaVidareTillSteg2(link, link.dataset.adress, arBostadsadress, extratext);
                } else {
                    visaAdresser(link);
                }
            }
        });
    }

    function setWizardGaVidareTillBeskrivning() {
        document.getElementById('w-steg-1').classList.add('d-none');
        document.getElementById('w-link-steg-1').classList.remove('d-none');
        document.getElementById('w-steg-1').classList.remove('active');

        document.getElementById('w-steg-2').classList.add('active');
        document.getElementById('w-steg-2').scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
        });
    }

    function initWizardTillbakaTillSteg1() {

        document.getElementById('tillbaka-till-steg1').addEventListener('click', gaTillbakaTillSteg1);
        document.getElementById('w-link-steg-1').addEventListener('click', gaTillbakaTillSteg1);
    }

    function initWizardGaVidareTillKontaktuppgifter() {
        const gaVidareKnapp = document.getElementById('ga-vidare-till-kontaktuppgifter');
        gaVidareKnapp.addEventListener('click', gaVidareTillKontaktuppgifter);
    }
    
    function initWizardTillbakaTillBeskrivning() {
        document.getElementById('tillbaka-till-beskrivning').addEventListener('click', gaTillbakaTillBeskrivning);
        document.getElementById('w-link-steg-2').addEventListener('click', gaTillbakaTillBeskrivning);
        document.getElementById('ga-vidare-knapp').addEventListener('click', gaTillbakaTillBeskrivning);
    }

    function gaTillbakaTillSteg1() {
        doljFelmeddelande();

        document.querySelector('#felanmalan-formular-beskrivning .kundservice-telefon small').innerHTML = '';
        document.querySelector('[id$=ValdAdress]').value = '';
        document.querySelector('[id$=FastighetsEpostadress]').value = '';

        document.getElementById('felanmalan-formular-beskrivning').classList.add('d-none');
        document.getElementById('felanmalan-formular-kontaktuppgifter').classList.add('d-none');
        document.getElementById('felanmalan-w1').classList.remove('d-none');

        if (document.getElementById('ga-vidare-adress').classList.contains('d-none')) {
            document.getElementById('ga-vidare-knapp').classList.remove('d-none');
        }
        

        document.querySelectorAll('[id^="w-steg-"]').forEach(function (e) { e.classList.remove('d-none'); });
        document.querySelectorAll('[id^="w-steg-"]').forEach(function (e) { e.classList.remove('active'); });
        document.querySelectorAll('[id^="w-link-steg-"]').forEach(function (e) { e.classList.add('d-none'); });

        document.getElementById('w-steg-1').classList.add('active');
        document.getElementById('w-steg-1').scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
        });

        document.getElementById('felanmalansida').setAttribute('style', '');
        document.getElementById('felanmalan-w4').classList.add('d-none');
    }

    function gaVidareTillKontaktuppgifter() {
        var gaVidareTillKontaktUppgifter = false;
        const MAX_FILE_SIZE = AlectaFastigheter.CustomMultifile.getMaxFileSize();
        const totalFileSize = (AlectaFastigheter.CustomMultifile.sumFileSizes(AlectaFastigheter.CustomMultifile.uploadedFiles) / 1024).toFixed(2);
        const beskrivning_tvingad = $('#Formular_Beskrivning').val().trim().length >= 1;

        if (beskrivning_tvingad) {
            doljFelmeddelande();
        } else {
            visaFelmeddelande();
        }

        if (totalFileSize <= MAX_FILE_SIZE) {
            doljFilFelmeddelande();
        } else {
            visaFilFelmeddelande();
        }

        if (totalFileSize <= MAX_FILE_SIZE && beskrivning_tvingad) {
            gaVidareTillKontaktUppgifter = true;
        } else {
            gaVidareTillKontaktUppgifter = false;
        }

        if (gaVidareTillKontaktUppgifter) {

            document.getElementById('felanmalan-formular-beskrivning').classList.add('d-none');
            document.getElementById('felanmalan-formular-kontaktuppgifter').classList.remove('d-none');

            document.getElementById('w-steg-2').classList.add('d-none');
            document.getElementById('w-link-steg-2').classList.remove('d-none');
            document.getElementById('w-steg-2').classList.remove('active');

            document.getElementById('w-steg-3').classList.add('active');
            document.getElementById('w-steg-3').scrollIntoView({
                behavior: 'auto',
                block: 'center',
                inline: 'center'
            });
        }
    }

    function gaTillbakaTillBeskrivning() {
        doljFelmeddelande();
        document.getElementById('felanmalan-formular-beskrivning').classList.remove('d-none');
        document.getElementById('felanmalan-formular-kontaktuppgifter').classList.add('d-none');
        document.getElementById('felanmalan-w1').classList.add('d-none');

        document.getElementById('Formular_Namn').classList.remove('is-invalid');
        document.getElementById('Formular_Foretag').classList.remove('is-invalid');
        document.getElementById('Formular_Telefon').classList.remove('is-invalid');
        document.getElementById('Formular_Mejladress').classList.remove('is-invalid');

        document.querySelectorAll('[id^="w-steg-"]').forEach(function (e) { e.classList.remove('d-none'); });
        document.querySelectorAll('[id^="w-steg-"]').forEach(function (e) { e.classList.remove('active'); });
        document.querySelectorAll('[id^="w-link-steg-"]').forEach(function (e) { e.classList.add('d-none'); });

        document.getElementById('w-link-steg-1').classList.remove('d-none');
        document.getElementById('w-steg-1').classList.add('d-none');
        document.getElementById('w-steg-2').classList.add('active');
        document.getElementById('w-steg-2').scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
        });
    }

    function visaAdresser(link) {
        const fastighetId = link.getAttribute('data-fastighet-id');
        const extraText = link.getAttribute('data-extraText');
        const adressval = document.getElementById('adresser-' + fastighetId);

        const adresser = document.querySelectorAll('[id^="adresser-"]');

        adresser.forEach(el => { el.classList.add('d-none') });

        adressval.classList.remove('d-none');

        const gaVidareKnapp = document.getElementById('ga-vidare-adress');
        gaVidareKnapp.classList.remove('d-none');
        gaVidareKnapp.addEventListener('click', function (e) {
            var adressSelect = document.getElementById('select-adress-' + fastighetId);
            var option = adressSelect.options[adressSelect.selectedIndex];
            if ((option.value == '')) {
                visaFelmeddelandeOmAdressEjArVald();
            }
            else {
                doljFelmeddelandeOmAdressEjArVald();
                gaVidareTillSteg2(link, option.value, option.dataset.arBostadsadress, extraText);
            }
        });
    }

    function visaFelmeddelandeOmAdressEjArVald() {
        var invalid = document.getElementsByClassName('ingen-adress-vald');
        invalid.display = '';
        invalid[0].innerHTML = 'Välj en adress';
    }

    function doljFelmeddelandeOmAdressEjArVald() {
        var invalid = document.getElementsByClassName('ingen-adress-vald');
        invalid[0].innerHTML = '';
        invalid.display = 'none';
    }

    function gaTillPrivatFelanmalan() {
        $('#privat-bostad-modal').modal('hide');
        document.getElementById('felanmalan-w1').classList.add('d-none');
        
        visaFormular(
            document.getElementById('privat-felanmalan').getAttribute('data-namn'),
            document.getElementById('privat-felanmalan').getAttribute('data-adress'),
            document.getElementById('privat-felanmalan').getAttribute('data-kontaktinformation'),
            document.getElementById('privat-felanmalan').getAttribute('data-mejladress'),
            document.getElementById('privat-felanmalan').getAttribute('data-extraText')
        );
    }

    function gaVidareTillSteg2(link, adress,  arBostadsadress, extraText) {
        
        const externFelanmalan = document.getElementById('externfelanmalan-' + link.dataset.fastighetId);

        if (arBostadsadress === 'true') {
            $('#privat-bostad-modal').modal('show');
            document.getElementById('felanmalan-w1').classList.remove('d-none');
            document.getElementById('privat-felanmalan').setAttribute('data-namn', link.dataset.namn);
            document.getElementById('privat-felanmalan').setAttribute('data-adress', adress);
            document.getElementById('privat-felanmalan').setAttribute('data-kontaktinformation', link.dataset.kontaktinformation);
            document.getElementById('privat-felanmalan').setAttribute('data-mejladress', link.dataset.mejladress);
            document.getElementById('privat-felanmalan').addEventListener('click', gaTillPrivatFelanmalan);
        }
        else if (!extraText && !link.dataset.mejladress){
            $('#extern-felanmalan-modal .modal-body').empty();
            $('#extern-felanmalan-modal .modal-body').append(externFelanmalan.innerHTML);
            $('#extern-felanmalan-modal').modal('show');
            document.getElementById('felanmalan-w1').classList.remove('d-none');
        }

        else if (externFelanmalan.innerHTML) {
            
            if (link.dataset.mejladress) {
                document.getElementById('felanmalan-w1').classList.add('d-none');
                visaFormular(link.dataset.namn, adress, link.dataset.kontaktinformation, link.dataset.mejladress, extraText);
            }

            else {
                $('#extern-felanmalan-modal .modal-body').empty();
                $('#extern-felanmalan-modal .modal-body').append(externFelanmalan.innerHTML);
                $('#extern-felanmalan-modal').modal('show');
                document.getElementById('felanmalan-w1').classList.remove('d-none');
            }
        }
        else {
            document.getElementById('felanmalan-w1').classList.add('d-none');
            visaFormular(link.dataset.namn, adress, link.dataset.kontaktinformation, link.dataset.mejladress, extraText);
        }
    }

    function visaFormular(fastighetsnamn, adress, kontaktinfo, fastighetsepostadress, extraText) {
        document.querySelector('#felanmalan-formular-beskrivning h2').innerHTML = fastighetsnamn;
        document.querySelector('#felanmalan-formular-beskrivning h3').innerHTML = adress;
        document.querySelector('#felanmalan-formular-beskrivning p').innerHTML = extraText;
        document.querySelector('#felanmalan-formular-beskrivning .kundservice-telefon small').innerHTML = kontaktinfo;
        document.querySelector('[id$=ValdAdress]').value = adress;
        document.querySelector('[id$=FastighetsEpostadress]').value = fastighetsepostadress;

        document.getElementById('felanmalan-formular-beskrivning').classList.remove('d-none');

        setWizardGaVidareTillBeskrivning();
    }

    function doljFelmeddelande() {
        document.querySelector('.feedback-beskrivning').innerHTML = '';
        document.querySelector('.feedback-beskrivning').style.display = 'none';
    }

    function visaFelmeddelande() {
        document.querySelector('.feedback-beskrivning').style.display = '';
        document.querySelector('.feedback-beskrivning').innerHTML = 'Skriv din felbeskrivning';
    }

    function doljFilFelmeddelande() {
        document.querySelector('.invalid-feedback.feedback-filer').innerHTML = '';
        document.querySelector('.invalid-feedback.feedback-filer').style.display = 'none';
    }

    function visaFilFelmeddelande() {
        document.querySelector('.invalid-feedback.feedback-filer').style.display = 'block';
        document.querySelector('.invalid-feedback.feedback-filer').innerHTML = AlectaFastigheter.CustomMultifile.getValidationText();
    }

})();
